import React from "react";

const Button = ({
  children,
  onClick,
  disabled = false,
  variant = "primary",
  size = "md",
  className,
}) => {
  const baseStyles = "font-medium rounded-lg focus:outline-none";
  const sizeStyles = {
    sm: "px-3 py-1 text-sm",
    md: "px-4 py-2 text-base",
    lg: "px-6 py-3 text-lg",
  };
  const variantStyles = {
    primary: "bg-[#00bbd4] text-white hover:bg-[#51c5d4] active:bg-[#029cb0]",
    secondary: "bg-[#FFC107] text-white hover:bg-[#daa509] ",
    danger: "bg-red-500 text-white hover:bg-red-600 focus:ring-red-300  ",
    transparent: "bg-transparent text-black underline",
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${sizeStyles[size]} ${variantStyles[variant]} ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
